import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { Radio } from 'synfrastructure';
import _ from 'lodash';
import get from 'lodash/get';

import Loading from '../../common/components/Loading';
import Icon from '../../common/icons/Icon';
import TwoStepButton from '../../common/components/TwoStepButton';
import InputScaffold from '../../common/forms/InputScaffold';
import ToggleScaffold from '../../common/forms/ToggleScaffold';
import CropperScaffold from '../../common/forms/CropperScaffold';
import ReduxFormsImageCropper from '../../common/forms/ReduxFormsImageCropper';
import dataUrlToFile from '../../common/utils/dataUrlToFile';

import {
  getDailyExtra,
  createDailyExtra,
  deleteDailyExtra,
  updateDailyExtra,
  getLibraryVideoInfoByCategory,
} from '../actions';

const DEFAULT_DAILY_EXTRALESS_STATE = {
  clearOrigImage: false,
  dailyExtra: null,
  editing: false,
  errors: {},
  saving: false,
};

const DEFAULT_EMPTY_DAILY_EXTRA = {
  mediaOption: 'Image',
  image_id: null,
  image: {
    location: '',
  },
  library_video_id: '',
  name: '',
  header: '',
  body_text: '',
  button_text: '',
  button_link: '',
  button_new_window: true,
};

const setOnDailyExtraState = (key, dailyExtra, value) => ({
  dailyExtra: {
    ...dailyExtra,
    [key]: value,
  },
});

const validate = values => {
  const errors = [];
  const { name, mediaOption, image, library_video_id, button_text, button_link } = values;

  if (!name.trim()) {
    errors.name = ['Name cannot be blank'];
  }

  if (mediaOption === 'Video' && !library_video_id) {
    errors.library_video_id = ['Must choose a video'];
  }

  if (mediaOption === 'Image') {
    if (!image) {
      errors.image = ['Must choose an image'];
    }

    if (button_text.trim() && !button_link.trim()) {
      errors.button_link = ['Button link cannot be blank'];
    }
  }

  return errors;
};

class DailyExtraBuilder extends Component {
  static propTypes = {
    dailyExtraId: PropTypes.number,
    lessonId: PropTypes.number.isRequired,
    loaded: PropTypes.bool,
    dailyExtra: PropTypes.object,
    dailyExtraVideoInfo: PropTypes.func,
  };

  state = DEFAULT_DAILY_EXTRALESS_STATE;

  componentDidMount() {
    if (this.props.dailyExtraId) {
      this.props.getDailyExtra(this.props.dailyExtraId);
    }

    this.props.dailyExtraVideoInfo().then(result => {
      this.setState({
        dailyExtraVideoInfo: result,
      });
    });
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.loaded && nextProps.loaded) {
      const dailyExtra = this.formatDailyExtra(nextProps.dailyExtra);

      this.setState({ dailyExtra });
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.dailyExtraId && nextProps.dailyExtraId !== this.props.dailyExtraId) {
      this.props.getDailyExtra(nextProps.dailyExtraId);
    }
  }

  formatDailyExtra(dailyExtra) {
    const formattedDailyExtra = dailyExtra.toJS();
    const shouldNotBeNull = ['body_text', 'button_link', 'button_text', 'header', 'library_video_id', 'name'];

    delete formattedDailyExtra.id;

    formattedDailyExtra.mediaOption = 'Image';
    if (formattedDailyExtra.library_video_id) {
      formattedDailyExtra.mediaOption = 'Video';
    }

    shouldNotBeNull.forEach(value => {
      if (!formattedDailyExtra[value]) {
        formattedDailyExtra[value] = '';
      }
    });

    return formattedDailyExtra;
  }

  handleAddDailyExtra = () => {
    this.setState({
      editing: true,
      dailyExtra: DEFAULT_EMPTY_DAILY_EXTRA,
    });
  };

  handleSubmit = values => {
    const sendDailyExtra = _.cloneDeep(this.state.dailyExtra);

    if (values.image) {
      sendDailyExtra.image = dataUrlToFile(values.image.imageResult, values.image.imageFilename);
    }

    if (!this.state.clearOrigImage) {
      sendDailyExtra.image_id = this.state.image_id;
    }

    this.setState({
      image: values.image,
    });

    const errors = validate(sendDailyExtra);
    if (!Object.keys(errors).length) {
      this.setState({
        editing: false,
        saving: true,
      });

      this.props.submitAction(sendDailyExtra).then(() => {
        this.setState({
          saving: false,
          errors: {},
        });
      });
    } else {
      this.setState({
        errors,
      });
    }
  };

  handleCancel = e => {
    e.preventDefault();
    if (this.props.dailyExtra) {
      const dailyExtra = this.formatDailyExtra(this.props.dailyExtra);
      this.setState({
        editing: false,
        errors: {},
        dailyExtra,
      });
    } else {
      this.setState(DEFAULT_DAILY_EXTRALESS_STATE);
    }
  };

  handleDelete = e => {
    this.setState({ saving: true });

    if (this.props.dailyExtraId) {
      this.props.deleteDailyExtra().then(thing => {
        this.setState({
          saving: false,
          ...DEFAULT_DAILY_EXTRALESS_STATE,
        });
      });
    }
  };

  handleRemoveImage = () => {
    this.setState(state => ({ clearOrigImage: true }));
  };

  renderImageForm = () => {
    const { clearOrigImage, dailyExtra, errors } = this.state;
    return (
      <div>
        {dailyExtra && dailyExtra.image_id && !clearOrigImage ? (
          <CropperScaffold label="Daily Extra Image" required>
            <div className="original-image">
              <img alt="daily extra" src={dailyExtra.image.location} />
            </div>
            <div className="cropper-scaffold__controls">
              <button type="button" className="button button--theme--outline" onClick={this.handleRemoveImage}>
                Remove Image
              </button>
            </div>
          </CropperScaffold>
        ) : (
          <Field name="image" component={ReduxFormsImageCropper} label="Daily Extra Image" />
        )}
        {this.renderSharedFormElements()}
        <InputScaffold label={`What is the button text?`}>
          <input
            type="text"
            value={dailyExtra.button_text}
            onChange={this.handleFieldUpdate.bind(this, 'button_text')}
          />
        </InputScaffold>
        <InputScaffold
          label={`Where should the button link to? (Paste URL here.)`}
          validation={get(errors, ['button_link'])}
        >
          <input
            type="text"
            value={dailyExtra.button_link}
            onChange={this.handleFieldUpdate.bind(this, 'button_link')}
          />
        </InputScaffold>
        <div className="daily-extra-builder__check-scaffold">
          <p>How should the link open?</p>
          <div className="toggle-scaffold__wrapper">
            <ToggleScaffold key={'New Tab'} label={'New Tab'} className={dailyExtra.button_new_window ? 'checked' : ''}>
              <Radio
                id={'New Tab'}
                value={'New Tab'}
                checked={dailyExtra.button_new_window}
                onChange={this.toggleNewWindow.bind(this)}
              />
            </ToggleScaffold>
            <ToggleScaffold
              key={'Existing Tab'}
              label={'Existing Tab'}
              className={dailyExtra.button_new_window ? '' : 'checked'}
            >
              <Radio
                id={'Existing Tab'}
                value={'Existing Tab'}
                checked={!dailyExtra.button_new_window}
                onChange={this.toggleNewWindow.bind(this)}
              />
            </ToggleScaffold>
          </div>
        </div>
      </div>
    );
  };

  renderVideoForm = () => {
    const { dailyExtra, dailyExtraVideoInfo, errors } = this.state;

    return (
      <div>
        <InputScaffold
          label="Which library video will the Daily Extra show?"
          validation={get(errors, ['library_video_id'])}
        >
          <select
            onChange={this.handleSelectFieldUpdate.bind(this, 'library_video_id')}
            value={dailyExtra.library_video_id}
          >
            <option value="" />

            {dailyExtraVideoInfo.map(videoInfo => (
              <option key={videoInfo.id} value={videoInfo.id}>
                {videoInfo.name}
              </option>
            ))}
          </select>
        </InputScaffold>
        {this.renderSharedFormElements()}
      </div>
    );
  };

  renderSharedFormElements = () => {
    const { dailyExtra } = this.state;
    return (
      <div>
        <InputScaffold label={`What is the header?`}>
          <input type="text" value={dailyExtra.header} onChange={this.handleFieldUpdate.bind(this, 'header')} />
        </InputScaffold>
        <InputScaffold label={`What is the body text?`}>
          <textarea value={dailyExtra.body_text} onChange={this.handleFieldUpdate.bind(this, 'body_text')} />
        </InputScaffold>
      </div>
    );
  };

  renderEditForm = () => {
    const { dailyExtra, editing, errors } = this.state;
    const mediaOptions = ['Image', 'Video'];

    return (
      <div className="daily-extra-builder__wrapper">
        <form onSubmit={this.props.handleSubmit(this.handleSubmit)} className="daily-extra-builder">
          <InputScaffold label={`Name`} validation={get(errors, ['name'])}>
            <input type="text" value={dailyExtra.name} onChange={this.handleFieldUpdate.bind(this, 'name')} />
          </InputScaffold>
          <div className="daily-extra-builder__check-scaffold">
            <p>What kind of Media will the Daily Extra contain?</p>
            <div className="toggle-scaffold__wrapper">
              {mediaOptions.map(option => {
                return (
                  <ToggleScaffold
                    key={option}
                    label={option}
                    className={dailyExtra.mediaOption === option ? 'checked' : ''}
                  >
                    <Radio
                      id={option}
                      value={option}
                      checked={dailyExtra.mediaOption === option}
                      onChange={this.handleFieldUpdate.bind(this, 'mediaOption')}
                    />
                  </ToggleScaffold>
                );
              })}
            </div>
          </div>
          {dailyExtra.mediaOption === 'Image' && this.renderImageForm()}
          {dailyExtra.mediaOption === 'Video' && this.renderVideoForm()}
          {this.renderSubmitButtons(editing)}
        </form>
      </div>
    );
  };

  renderNotEditingDisplay = () => {
    const { dailyExtra } = this.state;

    return (
      <div>
        <ul className="admin-paper__list">
          <li>
            <div className="admin-paper__list__title">{dailyExtra.name}</div>
            <div className="admin-paper__list__actions">
              <span onClick={this.startEditing.bind(this)}>
                <Icon icon="Pencil" />
              </span>
              <TwoStepButton iconButton={true} onConfirm={this.handleDelete} />
            </div>
          </li>
        </ul>
      </div>
    );
  };

  renderNoDailyExtraDisplay = () => {
    return (
      <div className="daily-extra-builder__add-daily-extra">
        This lesson does not have a Daily Extra.
        <button type="button" className="admin__add-button" onClick={this.handleAddDailyExtra}>
          <Icon icon="Plus" />
          Add Daily Extra
        </button>
      </div>
    );
  };

  renderSubmitButtons = editing => {
    if (!editing) {
      return (
        <div className="daily-extra-builder__buttons">
          <div className="button__wrapper-right">
            <button type="button" className="button" onClick={this.startEditing}>
              Edit
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="daily-extra-builder__buttons">
        <div className="button__wrapper-right">
          <button type="button" className="button button--theme--plain" onClick={this.handleCancel}>
            Cancel
          </button>
          <button className="button">Save</button>
        </div>
      </div>
    );
  };

  handleFieldUpdate = (fieldName, e) => {
    const value = e.target.value;
    this.setState(state => setOnDailyExtraState(fieldName, state.dailyExtra, value));
  };

  toggleNewWindow = e => {
    const value = e.target.value;
    const newWindowValue = value === 'New Tab';
    this.setState(state => setOnDailyExtraState('button_new_window', state.dailyExtra, newWindowValue));
  };

  handleSelectFieldUpdate = (fieldName, e) => {
    const selectedIndex = e.target.selectedIndex;
    const value = e.target[selectedIndex].value;
    this.setState(state => setOnDailyExtraState(fieldName, state.dailyExtra, value));
  };

  startEditing = () => {
    this.setState({
      editing: true,
    });
  };

  render() {
    if (this.state.editing) {
      return this.renderEditForm();
    }
    if (this.props.loaded && this.props.dailyExtra && this.state.dailyExtra) {
      return this.renderNotEditingDisplay();
    }
    if (this.state.saving || (this.props.dailyExtraId && !this.props.loaded)) {
      return <Loading />;
    }
    return this.renderNoDailyExtraDisplay();
  }
}

const mapStateToProps = state => {
  return {
    loaded: state.courses.dailyExtra.get('loaded'),
    dailyExtra: state.courses.dailyExtra.get('data'),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    dailyExtraVideoInfo: () => dispatch(getLibraryVideoInfoByCategory(2)).then(result => result.json.rows),
    getDailyExtra: dailyExtraId => {
      dispatch(getDailyExtra(dailyExtraId)).then(result => {
        return result;
      });
    },
    deleteDailyExtra: () => dispatch(deleteDailyExtra(ownProps.dailyExtraId, ownProps.lessonId)),
    submitAction: dailyExtra => {
      let formattedDailyExtra = _.omit(dailyExtra, ['lesson_id', 'mediaOption']);

      formattedDailyExtra.library_video_id = null;
      formattedDailyExtra.image = null;

      if (dailyExtra.mediaOption === 'Video') {
        formattedDailyExtra.library_video_id = dailyExtra.library_video_id;
        let libraryVideoId = parseInt(formattedDailyExtra.library_video_id, 10);
        if (libraryVideoId) {
          formattedDailyExtra.library_video_id = libraryVideoId;
        }
      } else if (dailyExtra.mediaOption === 'Image') {
        formattedDailyExtra.image = dailyExtra.image;
      }

      formattedDailyExtra = _.pickBy(formattedDailyExtra, value => value !== null && value !== undefined);

      if (ownProps.dailyExtraId) {
        return dispatch(updateDailyExtra(ownProps.dailyExtraId, formattedDailyExtra));
      } else {
        return dispatch(createDailyExtra(ownProps.lessonId, formattedDailyExtra));
      }
    },
  };
};

export default reduxForm({ form: 'dailyExtraBuilder' })(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(DailyExtraBuilder))
);



// WEBPACK FOOTER //
// ./src/courses/daily-extras/DailyExtraBuilder.js